import { niTrackEvent } from '@xsite-ui/common.event-tracker';

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function initMiniReviews() {
  var miniReviewItem = document.querySelectorAll('.chart-mini-reviews__item');
  var overlay = document.querySelector('[data-role-id="overlay"]');
  var miniReviewToggleButtons = document.querySelectorAll('.mini-reviews-wrapper .toggle-button');

  var _iterator = _createForOfIteratorHelper(miniReviewToggleButtons),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var button = _step.value;
      button.addEventListener('click', toggleMiniReview);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (miniReviewItem) {
    var _iterator2 = _createForOfIteratorHelper(miniReviewItem),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var item = _step2.value;

        var _iterator3 = _createForOfIteratorHelper(item.querySelectorAll('[data-event-action]')),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var link = _step3.value;
            link.addEventListener('click', sendUIEvent);
          } // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore

        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        item.querySelector('.close-btn').addEventListener('click', closeMiniReview);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  overlay === null || overlay === void 0 ? void 0 : overlay.addEventListener('click', closeMiniReview);
}

function toggleMiniReview(e) {
  var body = document.querySelector('body');
  var allMiniReviews = document.querySelector('.chart-mini-reviews');
  e.stopPropagation();
  var element = e.target;
  sendUIEvent(e);
  var currentProductId = element.dataset.productId;

  if (currentProductId) {
    var currentMiniReview = allMiniReviews === null || allMiniReviews === void 0 ? void 0 : allMiniReviews.querySelector(".chart-mini-reviews__item[data-product-id=\"".concat(currentProductId, "\"]"));

    if (currentMiniReview) {
      body === null || body === void 0 ? void 0 : body.classList.add('show-page-overlay');
    }
  }
}

function closeMiniReview() {
  var body = document.querySelector('body');
  var miniReviewInputs = document.querySelectorAll('input[id^="mini-review"]');

  if (miniReviewInputs) {
    var _iterator4 = _createForOfIteratorHelper(miniReviewInputs),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var input = _step4.value;
        input.checked = false;
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }

  body === null || body === void 0 ? void 0 : body.classList.remove('show-page-overlay');
}

function sendUIEvent(e) {
  var element = e.target;
  var action = getActionValue(element);
  var productName = element.dataset.productName || element.closest('[data-product-name]').dataset.productName;
  niTrackEvent({
    category: 'Mini Reviews',
    action: "Click on ".concat(action),
    optLabel: productName,
    optValue: 0,
    optNonInteraction: false
  });
}

function getActionValue(element) {
  var action = element.dataset.eventAction;

  if (!action) {
    var closestWithDataAttribute = element.closest('[data-event-action]');
    action = closestWithDataAttribute !== null ? closestWithDataAttribute.dataset.eventAction : '';
  }

  return action || 'quick view link';
}

export { initMiniReviews };
